import Splide from '@splidejs/splide';

const anniversaryNancy = document.querySelector('.splide-nancy-teaching');
const anniversaryTimeline = document.querySelector('.splide-anniversary-timeline');

if (anniversaryNancy) {
    const nancySplide = new Splide(anniversaryNancy, {
        type: 'loop',
        perPage: 3,
        gap: '48px',
        arrows: false,
        focus: 'center',
        perMove: 1,
        trimSpace: false,

        breakpoints: {
		      799: {
			      perPage: 1,
            gap: '24px',
            trimSpace: true,
		      },
        }
    });

    nancySplide.mount();
}

if (anniversaryTimeline) {

  // Initialize the main content slider
  var primarySlider = new Splide('#primary-slider', {
    type: 'slide',
    perPage: 5,
    gap: '48px',
    pagination: false,
    rewind: false,
    arrows: false,
    drag: false,
    breakpoints: {
      1399: {
        perPage: 3,
      },
      799: {
        perPage: 1,
      }
    }
  });

  // Initialize the navigation/date slider
  var secondarySlider = new Splide('#secondary-slider', {
    type: 'slide',
    focus: 0,
    perPage: 5,
    gap: '48px',
    isNavigation: true,
    pagination: false,
    rewind: false,
    drag: false,
    breakpoints: {
      1399: {
        perPage: 3,
      },
      799: {
        perPage: 1,
      }
    }
  });

  // Sync the secondary slider to the primary one, then mount both
  primarySlider.sync(secondarySlider);

  primarySlider.mount();
  secondarySlider.mount();

}